// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`OfferElement test Match con el snapshot 1`] = `
<div class="container">
    <p class="label"></p>
    <!---->
    <p class="detail"></p>
</div>
`;
